import { createCsv, CreateCsvProps } from './create-csv';
import { downloadFile } from './download-file';

export type DownloadCsvProps<T> = (
  CreateCsvProps<T>
  & {
    /** Downloaded file name. */
    fileName?: string;
  }
);

/** Create and download a CSV file with the provided information in it. */
export function downloadCsv<T>({
  fileName,
  ...createCsvArgs
}: DownloadCsvProps<T>) {
  downloadFile({
    fileName: fileName ?? 'Download.csv',
    text: createCsv(createCsvArgs)
  });
}
